import { Injectable } from '@angular/core';
import { NodeService } from './node.service';
import { Token } from '../app/app.models';
import { Storage } from '@ionic/storage';

const name_db = 'tempAsset';

@Injectable()
export class WatacardLoadingSerivce {
  private tx: string = null;
  private tempAsset: Token;
  private index: number;

  constructor(private nodeService: NodeService, private storage: Storage) {
    this.storage.get(name_db).then(tempdata => {
      if (tempdata) {
        if (tempdata.tx) {
          this.tempAsset = tempdata.asset;
          this.tx = tempdata.tx;
          this.index = tempdata.index;
        }
      }
    });
  }

  setTemp(tx: string, asset: Token, index: number) {
    this.tempAsset = asset;
    this.tx = tx;
    this.index = index;
    this.storage.ready().then(() => {
      this.storage
        .set(name_db, { tx: tx, asset: asset, index: index })
        .then(tempAsset => {})
        .catch(err => {});
    });
  }

  setTempTx(tx: string) {
    this.tx = tx;
  }

  getTempIndex() {
    return this.index;
  }

  getTempAsset() {
    return this.storage.get(name_db).then(tempdata => {
      if (tempdata) {
        this.tempAsset = tempdata.asset;
        this.tx = tempdata.tx;
        this.index = tempdata.index;
        return this.tempAsset;
      }
    });
  }

  getTempTx() {
    return this.tx;
  }

  deleteTempAsset() {
    this.tempAsset = null;
    this.tx = null;
    this.index = null;
    this.storage.set(name_db, null).then(temp => {});
  }

  ///////////////////////////////////
  /**
 * 
 
  setTemp(tx: string, asset: any, index: number) {
    this.tempAsset = asset;
    this.tx = tx;
    this.index = index;
  }

  setTempAsset(asset: any, index: number) {
    this.tempAsset = asset;
    this.index = index;
  }

  setTempTx(tx: string) {
    this.tx = tx;
  }

  getTempIndex() {
    return this.index;
  }

  getTemp() {
    return { tempAsset: this.tempAsset, tx: this.tx };
  }

  getTempAsset() {
    return this.tempAsset;
  }

  getTempTx() {
    return this.tx;
  }

  deleteTempAsset() {
    this.tempAsset = null;
    this.tx = null;
    this.index = null;
  }
**/
  validateTransaction(asset) {
    return new Promise((resolve, reject) => {
      this.nodeService.getTransactionTemp(this.tx).then((result: any) => {
        if (result) {
          if (result.blockNumber == null) {
            return resolve(true);
          } else {
            return reject(false);
          }
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/watacard.loading.service.ts